import { graphql, useStaticQuery } from 'gatsby';

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          title
          author {
            name
            summary
            email
          }
          description
          siteUrl
          social {
            github
            linkedin
            rss
          }
          languages
          defaultLanguage
        }
      }
    }
  `);

  return data.site.siteMetadata;
};
